"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ArrowBack = _interopRequireDefault(require("@tvg/fuse-icons/lib/ArrowBack"));
var _Close = _interopRequireDefault(require("@tvg/fuse-icons/lib/Close"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledDrawerHeader = require("./styled-drawer-header");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var forwardRef = _react["default"].forwardRef;
var propTypes = {
  title: _propTypes["default"].string.isRequired,
  backCallback: _propTypes["default"].func,
  closeCallback: _propTypes["default"].func,
  drawerHeadingId: _propTypes["default"].string,
  hasBackButton: _propTypes["default"].bool,
  hasDepth: _propTypes["default"].bool,
  hasIcon: _propTypes["default"].bool,
  srLabelBackButton: _propTypes["default"].string,
  srLabelCloseButton: _propTypes["default"].string
};
var defaultProps = {
  backCallback: function backCallback() {},
  closeCallback: function closeCallback() {},
  drawerHeadingId: undefined,
  hasBackButton: false,
  hasDepth: false,
  hasIcon: false,
  srLabelBackButton: undefined,
  srLabelCloseButton: undefined
};
var DrawerHeader = forwardRef(function (_ref, ref) {
  var title = _ref.title,
    backCallback = _ref.backCallback,
    closeCallback = _ref.closeCallback,
    drawerHeadingId = _ref.drawerHeadingId,
    hasBackButton = _ref.hasBackButton,
    hasDepth = _ref.hasDepth,
    hasIcon = _ref.hasIcon,
    srLabelBackButton = _ref.srLabelBackButton,
    srLabelCloseButton = _ref.srLabelCloseButton;
  return /*#__PURE__*/_react["default"].createElement(_styledDrawerHeader.StyledDrawerHeader, {
    hasDepth: hasDepth,
    ref: ref
  }, hasBackButton && /*#__PURE__*/_react["default"].createElement(_styledDrawerHeader.StyledDrawerIconButton, {
    callback: backCallback,
    className: "fuse-drawer__back-button",
    icon: /*#__PURE__*/_react["default"].createElement(_ArrowBack["default"], null),
    "data-testid": "fuse-drawer-back-button-test-id",
    srLabel: srLabelBackButton
  }), /*#__PURE__*/_react["default"].createElement(_styledDrawerHeader.StyledDrawerHeading, {
    hasBackButton: hasBackButton,
    hasIcon: hasIcon,
    id: drawerHeadingId,
    "data-testid": "fuse-drawer-header-test-id",
    size: "3",
    type: "heading"
  }, title), /*#__PURE__*/_react["default"].createElement(_styledDrawerHeader.StyledDrawerIconButton, {
    callback: closeCallback,
    className: "fuse-drawer__close-button",
    icon: /*#__PURE__*/_react["default"].createElement(_Close["default"], null),
    "data-testid": "fuse-drawer-close-button-data-test-id",
    srLabel: srLabelCloseButton
  }));
});
DrawerHeader.propTypes = propTypes;
DrawerHeader.defaultProps = defaultProps;
var _default = exports["default"] = DrawerHeader;